import React from 'react'

import styled from '@emotion/styled'
import { mq, black02, green01, text, gray04 } from '../../_style'

const Container = styled.small`
  display: block;
  ${text('12px', 18 / 14)}
  color: ${gray04};
  & + & {
    padding-top: 8px;
  }
`
export default class Caption extends React.Component {
  render() {
    return(
      <Container>
        {this.props.children}
      </Container>
    )
  }
}
